module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3"
    }
  }, [_c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Date Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.DateTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "DateTypeFilter", $$v)
      },
      expression: "Filter.DateTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPendingSlineInvDDList'],
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransportTypeFilter", $$v)
      },
      expression: "Filter.TransportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Payment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.paymentTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Payment Type"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.paymentTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "paymentTypeFilter", $$v)
      },
      expression: "Filter.paymentTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("SOB Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.SOBFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SOBFilter", $$v)
      },
      expression: "Filter.SOBFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-5",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.DateTypeFilter ||
        _vm.Filter.JobNoFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.TransportTypeFilter ||
        _vm.Filter.paymentTypeFilter ||
        _vm.Filter.SOBFilter ||
        _vm.Filter.ShipemntTypeFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.DateTypeFilter ||
    _vm.Filter.JobNoFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.TransportTypeFilter ||
    _vm.Filter.paymentTypeFilter ||
    _vm.Filter.SOBFilter ||
    _vm.Filter.ShipemntTypeFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getPaymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-5",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getPaymentList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.DateTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "DateTypeFilter", $$v)
      },
      expression: "Filter.DateTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job NO Filter",
      "id": "JobNoFilter",
      "name": "JobNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.JobNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "JobNoFilter", $$v)
      },
      expression: "Filter.JobNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransportTypeFilter", $$v)
      },
      expression: "Filter.TransportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ShipemntTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ShipemntTypeFilter", $$v)
      },
      expression: "Filter.ShipemntTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPendingSlineInvDDList'],
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "id": "PORFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PORFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORFilter", $$v)
      },
      expression: "Filter.PORFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "id": "POLFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.POLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLFilter", $$v)
      },
      expression: "Filter.POLFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "id": "PODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODFilter", $$v)
      },
      expression: "Filter.PODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "id": "FPODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.FPODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODFilter", $$v)
      },
      expression: "Filter.FPODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getSlinePlanningList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center gap-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "checked": _vm.allSelected
    },
    on: {
      "change": function($event) {
        _vm.toggleSelectAll($event)
      }
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "btn-sm",
    attrs: {
      "variant": "primary",
      "disabled": _vm.selectedCheckBoxRows.length <= 0
    },
    on: {
      "click": function($event) {
        _vm.openConfirmModal(_vm.selectedCheckBoxRows)
      }
    }
  }, [_vm._v("\n              Finalize Request\n            ")])], 1)]), _vm._v(" "), _c('b-col', {
    staticClass: "table-responsive tableMain ",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getPaymentList,
      "fields": _vm.PaymentFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "row-class": _vm.rowClass
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "checkbox",
      fn: function(row0) {
        return [_c('div', {
          staticClass: "d-flex align-items-center gap-2"
        }, [_c('b-button', {
          staticClass: "mr-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": row0.toggleDetails
          }
        }, [_c('md-icon', [_vm._v(_vm._s(row0.detailsShowing ? "expand_less" : "expand_more"))]), _vm._v("\n                  " + _vm._s(row0.detailsShowing ? "Hide More" : "Show More") + "\n                  Details\n                ")], 1), _vm._v(" "), _c('b-form-checkbox', {
          attrs: {
            "disabled": row0.item.sprf_transaction_no,
            "value": {
              paymentModuleType: row0.item.paymentModuleType,
              sprf_id: row0.item.sprf_id,
              sps_id: row0.item.sps_id,
              sps_is_sortlist: row0.item.sps_is_sortlist,
              sps_is_finalized: row0.item.sps_is_finalized,
              invoicePayID: row0.item.invoicePayID,
              invoiceID: row0.item.invoiceID,
              invoiceAmtID: row0.item.invoiceAmtID,
              JobId: row0.item.JobId,
              JobNo: row0.item.JobNo,
              InvNumber: row0.item.invoiceNumber,
              InvAmt: row0.item.amount,
              currency: row0.item.currency,
              SlineName: row0.item.SlineName,
              shippingId: row0.item.shippingId,
              fk_sa_id: row0.item.fk_sa_id || null,
              JobDate: row0.item.JobDate || null,
              paymentCreatedDate: row0.item.paymentCreatedDate || null,
              invoiceType: row0.item.invoiceType || null,
              amount: row0.item.amount || null,
              payTo: row0.item.payTo || null,
              IFSCCode: row0.item.IFSCCode || null,
              BranchName: row0.item.BranchName || null,
              selectedAmt: row0.item.amount || null,
              ToBePaidAmt: row0.item.ToBePaidAmt || null,
            }
          },
          model: {
            value: (_vm.selectedCheckBoxRows),
            callback: function($$v) {
              _vm.selectedCheckBoxRows = $$v
            },
            expression: "selectedCheckBoxRows"
          }
        })], 1)]
      }
    }, {
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n              ")])]
      }
    }, {
      key: "invoiceNumber",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Transaction No:")]), _vm._v(_vm._s(row1.item.sprf_transaction_no)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Inv No:")]), _vm._v(_vm._s(row1.item.invoiceNumber)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Inv Date:")]), _vm._v(" " + _vm._s(row1.item.paymentCreatedDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Inv Amt:")]), _vm._v(" " + _vm._s(row1.item.amount)), _c('br'), _vm._v(" "), (_vm.isShortlisted(row1.item) || row1.item.sps_is_sortlist) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Shortlisted")]) : _vm._e(), _vm._v(" "), (row1.item.sps_is_finalized) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Finalized")]) : _vm._e()]
      }
    }, {
      key: "JobNo",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row1.item.JobNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(row1.item.JobDate)), _c('br')]
      }
    }, {
      key: "ClientName",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Pay To:")]), _vm._v(" " + _vm._s(row1.item.pay_to)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Forwarder Name:")]), _vm._v(" " + _vm._s(row1.item.ForwarderName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Sline Name:")]), _vm._v(" " + _vm._s(row1.item.SlineName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s(row1.item.ClientName)), _c('br')]
      }
    }, {
      key: "POR",
      fn: function(row1) {
        return [_c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row1.item.POR)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row1.item.POL)), _c('br')]
      }
    }, {
      key: "EnqNo",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Enq No:")]), _vm._v(" " + _vm._s(row1.item.EnqNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Enq Date:")]), _vm._v(" " + _vm._s(row1.item.EnqDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("SOB Date:")]), _vm._v(" " + _vm._s(row1.item.SOB)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Payment Module Type:")]), _vm._v(" " + _vm._s(row1.item.paymentModuleType)), _c('br')]
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [_c('b-row', [(row4.item.invoiceType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Type:")]), _vm._v(" " + _vm._s(row4.item.invoiceType))])]) : _vm._e(), _vm._v(" "), (row4.item.invoiceCategory) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Category :")]), _vm._v(" " + _vm._s(row4.item.invoiceCategory)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.currency) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Currency :")]), _vm._v(" " + _vm._s(row4.item.currency)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.slineBlNo) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Bl No :")]), _vm._v(" " + _vm._s(row4.item.slineBlNo)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.dueDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Due Date :")]), _vm._v(" " + _vm._s(row4.item.dueDate)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.sobDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Sob Date :")]), _vm._v(" " + _vm._s(row4.item.sobDate)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.paymentCreatedBy) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Created By :")]), _vm._v("\n                      " + _vm._s(row4.item.paymentCreatedBy)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.JobType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Job Type :")]), _vm._v(_vm._s(row4.item.JobType)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.JobTransportType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(row4.item.JobTransportType))])]) : _vm._e(), _vm._v(" "), (row4.item.JobTContainerType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Container Type:")]), _vm._v(" " + _vm._s(row4.item.JobTContainerType))])]) : _vm._e(), _vm._v(" "), (row4.item.RaisedFrom) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row4.item.RaisedFrom))])]) : _vm._e(), _vm._v(" "), (row4.item.RaisedBy) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(row4.item.RaisedBy))])]) : _vm._e(), _vm._v(" "), (row4.item.HBL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("HBL:")]), _vm._v(" " + _vm._s(row4.item.HBL))])]) : _vm._e(), _vm._v(" "), (row4.item.MBL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("MBL:")]), _vm._v(" " + _vm._s(row4.item.MBL))])]) : _vm._e(), _vm._v(" "), (row4.item.HBL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("HBL:")]), _vm._v(" " + _vm._s(row4.item.HBL))])]) : _vm._e(), _vm._v(" "), (row4.item.MBLDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("MBL Date:")]), _vm._v(" " + _vm._s(row4.item.MBLDate))])]) : _vm._e(), _vm._v(" "), (row4.item.MBLReleaseDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("MBL Release Date:")]), _vm._v(" " + _vm._s(row4.item.MBLReleaseDate))])]) : _vm._e(), _vm._v(" "), (row4.item.ExpClientName) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Exp Client Name:")]), _vm._v(" " + _vm._s(row4.item.ExpClientName))])]) : _vm._e(), _vm._v(" "), (row4.item.ImpClientName) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Imp Client Name:")]), _vm._v(" " + _vm._s(row4.item.ImpClientName))])]) : _vm._e(), _vm._v(" "), (row4.item.POD) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row4.item.POD))])]) : _vm._e(), _vm._v(" "), (row4.item.FPOD) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row4.item.FPOD))])]) : _vm._e(), _vm._v(" "), (row4.item.PICK) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("PICK:")]), _vm._v(" " + _vm._s(row4.item.PICK))])]) : _vm._e(), _vm._v(" "), (row4.item.STUFF) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("STUFF:")]), _vm._v(" " + _vm._s(row4.item.STUFF))])]) : _vm._e(), _vm._v(" "), (row4.item.HAND) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("HAND:")]), _vm._v(" " + _vm._s(row4.item.HAND))])]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "confirm-bulk-payment",
    staticClass: "w-90",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "id": "confirm-bulk-payment",
      "title": "Confirm Final to Release",
      "size": "xl",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v("Are you sure you want to proceed with this Invoice to Finalize?")])])], 1), _vm._v(" "), (_vm.selectedCheckBoxRows.length > 0) ? _c('b-card', [_c('b-card-body', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h2', {
    staticClass: "mb-4"
  }, [_vm._v("📦 Shipping Line Summary")]), _vm._v(" "), (_vm.alert.content) ? _c('h1', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.alert.content))]) : _vm._e(), _vm._v(" "), _c('b-row', _vm._l((_vm.shippingSummaryData), function(summary) {
    return _c('b-col', {
      key: summary.shippingId,
      staticClass: "mb-4",
      attrs: {
        "md": "12"
      }
    }, [_c('div', {
      staticClass: "border p-3 rounded bg-light"
    }, [_c('h6', {
      staticClass: "mb-3"
    }, [_vm._v(_vm._s(summary.shippingLine))]), _vm._v(" "), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
      staticClass: "mb-3",
      attrs: {
        "list": _vm.$store.getters['common/getAllShippingLineList'],
        "option-value": "shippingId",
        "option-text": "shippingLine",
        "placeholder": "Select Shipping Line",
        "isDisabled": true
      },
      on: {
        "input": function($event) {
          _vm.onShippingLineChange(summary.shippingId, summary.fk_sline_id)
        }
      },
      model: {
        value: (summary.fk_sline_id),
        callback: function($$v) {
          _vm.$set(summary, "fk_sline_id", $$v)
        },
        expression: "summary.fk_sline_id"
      }
    })], 1), _vm._v(" "), (summary.fk_sa_id) ? _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', [_vm._v("Currecny")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllCurrencyList'],
        "option-value": "currency_id",
        "option-text": "currencyCode",
        "placeholder": "Select Currency"
      },
      on: {
        "input": function($event) {
          _vm.getCurrencyDetails(summary.shippingId, summary.fk_currency_id)
        }
      },
      model: {
        value: (summary.fk_currency_id),
        callback: function($$v) {
          _vm.$set(summary, "fk_currency_id", $$v)
        },
        expression: "summary.fk_currency_id"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Currency-wise Totals:")])]), _vm._v(" "), _c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((summary.currencyTotals), function(amt, cur) {
      return _c('li', {
        key: cur
      }, [_vm._v("\n                      " + _vm._s(cur) + ": ₹" + _vm._s(amt.toLocaleString()) + "\n                    ")])
    })), _vm._v(" "), (summary.items.length > 0) ? _c('div', {
      staticClass: "mt-3 table-responsive-child"
    }, [_c('h6', {
      staticClass: "mb-3"
    }, [_vm._v("Invoice Details")]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-sm table-hover"
    }, [_c('thead', {
      staticClass: "thead-light"
    }, [_c('tr', [_c('th', {
      style: ('width:5%')
    }, [_vm._v("Job No")]), _vm._v(" "), _c('th', {
      style: ('width:5%')
    }, [_vm._v("Job Date")]), _vm._v(" "), _c('th', {
      style: ('width:8%')
    }, [_vm._v("Inv No")]), _vm._v(" "), _c('th', {
      style: ('width:5%')
    }, [_vm._v("Inv Created")]), _vm._v(" "), _c('th', {
      style: ('width:10%')
    }, [_vm._v("Inv Type")]), _vm._v(" "), _c('th', {
      style: ('width:5%')
    }, [_vm._v("Inv Amt")]), _vm._v(" "), _c('th', {
      style: ('width:20%')
    }, [_vm._v("Pay To")]), _vm._v(" "), _c('th', {
      style: ('width:8%')
    }, [_vm._v("Account No")]), _vm._v(" "), _c('th', {
      style: ('width:5%')
    }, [_vm._v("IFSC Code")]), _vm._v(" "), _c('th', {
      style: ('width:10%')
    }, [_vm._v("To Be Paid")])])]), _vm._v(" "), _c('tbody', _vm._l((summary.items), function(item1, index1) {
      return _c('tr', {
        key: index1
      }, [_c('td', [_vm._v(_vm._s(item1.JobNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.JobDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.InvNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.paymentCreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.invoiceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.amount))]), _vm._v(" "), _c('td', [_c('model-list-select', {
        staticClass: "mb-3",
        attrs: {
          "list": summary.getSlineAccList,
          "option-value": "value",
          "option-text": "label",
          "placeholder": "Select Account"
        },
        on: {
          "input": function($event) {
            _vm.getAccontDetailsItem(summary.shippingId, item1, index1, item1.fk_sa_id)
          }
        },
        model: {
          value: (item1.fk_sa_id),
          callback: function($$v) {
            _vm.$set(item1, "fk_sa_id", $$v)
          },
          expression: "item1.fk_sa_id"
        }
      })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.payTo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.IFSCCode))]), _vm._v(" "), _c('td', [(item1.fk_sa_id) ? _c('b-form-input', {
        staticClass: "mb-3",
        attrs: {
          "type": "text",
          "formatter": _vm.capitalizeAll,
          "placeholder": "To Be Paid Amount",
          "state": item1.ToBePaidAmt <= item1.amount
        },
        model: {
          value: (item1.ToBePaidAmt),
          callback: function($$v) {
            _vm.$set(item1, "ToBePaidAmt", _vm._n($$v))
          },
          expression: "item1.ToBePaidAmt"
        }
      }) : _vm._e(), _vm._v(_vm._s(item1.ToBePaidAmt) + "\n\n                            "), _vm._v(" "), (item1.ToBePaidAmt > item1.amount) ? _c('small', {
        staticClass: "text-danger"
      }, [_vm._v("\n                              Amount must be less than or equal to ₹" + _vm._s(item1.amount) + "\n                            ")]) : _vm._e()], 1)])
    }))])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "mt-2"
    }, [_c('strong', [_vm._v("Total: ₹" + _vm._s(summary.total.toLocaleString()))])])], 1)])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', {
    staticClass: "mt-4 text-right"
  }, [_vm._v("🧾 Grand Total: ₹" + _vm._s(_vm.shippingGrandTotal.toLocaleString()))]), _vm._v(" "), _vm._l((_vm.shippingGrandTotalCurrencyWise), function(amount, currency) {
    return _c('div', {
      key: currency
    }, [_c('h5', {
      staticClass: "mt-4 text-right"
    }, [_vm._v("🧾 Grand Total in " + _vm._s(currency) + ": " + _vm._s(amount))])])
  })], 2), _vm._v(" "), (_vm.selectedCheckBoxRows.length > 0) ? _c('b-col', {
    staticClass: " mt-2",
    attrs: {
      "md": "8"
    }
  }, [(_vm.alert.content) ? _c('h1', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.alert.content))]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2 btn-sm",
    attrs: {
      "variant": "primary",
      "disabled": _vm.selectedCheckBoxRows.length <= 0
    },
    on: {
      "click": _vm.handleConfirmOk
    }
  }, [(!_vm.isBulkPaymentProcessing) ? _c('span', [_vm._v("Finalize Request")]) : _c('span', [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v("\n                Processing...\n              ")], 1)]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2 btn-sm",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.resetModal
    }
  }, [_vm._v("\n              Cancel\n            ")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a36d038","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/payment/slinePaymentSortFinalList.vue
// module id = 2480
// module chunks = 0